// Card interactions: hover image scrub with dots, wishlist hearts, quick shop.
(function() {
  if (window.__sncCardsInit) return;
  window.__sncCardsInit = true;

  var WISHLIST_KEY = 'snc:wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('sannico:wishlist:change', { detail: { count: list.length } }));
  }

  // Serialize cart adds so concurrent taps can't race the /cart.js count or interleave.
  var addChain = Promise.resolve();
  function addToCart(vid, onDone, onFail, clubHandle) {
    var id = parseInt(vid, 10);
    if (!id) { onFail(new Error('no variant')); return; }
    addChain = addChain.then(function() {
      // One club per order: clear the cart first if it holds another club's items.
      var clearIfNeeded = window.sncClubCartClear ? window.sncClubCartClear(clubHandle) : Promise.resolve();
      return clearIfNeeded.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
      })
        .then(function(r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item_count: cart.item_count } }));
          document.dispatchEvent(new CustomEvent('sannico:cart:open'));
          onDone(cart);
        })
        .catch(function(err) { onFail(err); });
    });
    return addChain;
  }

  function initScrub(card) {
    var media = card.querySelector('[data-card-media]');
    var img = card.querySelector('.snc-card__image--primary');
    if (!media || !img) return;
    var urls = (card.dataset.images || '').split('|').filter(Boolean);
    if (urls.length < 2) return;
    if (urls.length > 4) urls = urls.slice(0, 4);

    var dots = document.createElement('div');
    dots.className = 'snc-card__dots';
    urls.forEach(function(_, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-on';
      dots.appendChild(d);
    });
    media.appendChild(dots);
    card.classList.add('has-scrub');

    var current = 0;
    var ready = false;
    var rect = null;

    function show(i) {
      if (i === current || !urls[i]) return;
      current = i;
      img.src = urls[i];
      var kids = dots.children;
      for (var k = 0; k < kids.length; k++) kids[k].className = k === i ? 'is-on' : '';
    }

    card.addEventListener('mouseenter', function() {
      if (!ready) {
        ready = true;
        // Drop the responsive hints so an imperative .src actually controls the displayed image.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        urls[0] = img.src;
        urls.forEach(function(u) { var p = new Image(); p.src = u; });
      }
      rect = media.getBoundingClientRect();
    });
    card.addEventListener('mousemove', function(e) {
      if (e.target.closest && e.target.closest('.snc-card__shop')) return;
      if (!rect) rect = media.getBoundingClientRect();
      if (e.clientY < rect.top || e.clientY > rect.bottom) return;
      var i = Math.floor(((e.clientX - rect.left) / rect.width) * urls.length);
      show(Math.max(0, Math.min(urls.length - 1, i)));
    });
    card.addEventListener('mouseleave', function() { show(0); });
  }

  function syncHeart(card) {
    var btn = card.querySelector('[data-card-fav]');
    if (!btn) return;
    var on = readWishlist().indexOf(card.dataset.handle) > -1;
    btn.classList.toggle('is-faved', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function initHeart(card) {
    var btn = card.querySelector('[data-card-fav]');
    if (!btn) return;
    syncHeart(card);

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var handle = card.dataset.handle;
      var list = readWishlist();
      var at = list.indexOf(handle);
      if (at > -1) {
        list.splice(at, 1);
      } else {
        list.push(handle);
        btn.classList.add('is-popped');
        setTimeout(function() { btn.classList.remove('is-popped'); }, 350);
      }
      writeWishlist(list);
    });
  }

  function initQuickAdd(card) {
    var btn = card.querySelector('button[data-card-add]');
    if (!btn) return;
    var variantSelect = card.querySelector('[data-card-variant]');
    var label = btn.textContent;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      var vid = variantSelect ? variantSelect.value : card.dataset.vid;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      addToCart(vid, function() {
        btn.textContent = 'Added';
        setTimeout(function() { btn.textContent = label; btn.disabled = false; }, 1200);
      }, function() {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }, card.dataset.club);
    });
  }

  function initSizes(card) {
    card.querySelectorAll('[data-card-size]').forEach(function(chip) {
      chip.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (chip.disabled || chip.classList.contains('is-busy')) return;
        chip.classList.remove('is-error');
        chip.classList.add('is-busy');
        addToCart(chip.dataset.vid, function() {
          chip.classList.remove('is-busy');
        }, function() {
          chip.classList.remove('is-busy');
          chip.classList.add('is-error');
          setTimeout(function() { chip.classList.remove('is-error'); }, 1600);
        }, card.dataset.club);
      });
    });
  }

  function setShop(card, open) {
    var toggle = card.querySelector('[data-card-shop-toggle]');
    card.classList.toggle('is-shop-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeShops(except) {
    document.querySelectorAll('[data-snc-card].is-shop-open').forEach(function(card) {
      if (card !== except) setShop(card, false);
    });
  }

  function initShopToggle(card) {
    var toggle = card.querySelector('[data-card-shop-toggle]');
    if (!toggle) return;
    var close = card.querySelector('[data-card-shop-close]');
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeShops(card);
      setShop(card, true);
    });
    if (close) {
      close.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setShop(card, false);
      });
    }
  }
  document.addEventListener('click', function(e) {
    var shop = e.target.closest && e.target.closest('[data-card-shop]');
    closeShops(shop ? shop.closest('[data-snc-card]') : null);
  });
  document.addEventListener('sannico:cart:open', function() { closeShops(null); });

  function boot() {
    document.querySelectorAll('[data-snc-card]').forEach(function(card) {
      if (card.dataset.sncInited === '1') return;
      card.dataset.sncInited = '1';
      initScrub(card);
      initHeart(card);
      initQuickAdd(card);
      initSizes(card);
      initShopToggle(card);
    });
  }

  function syncAllHearts() {
    document.querySelectorAll('[data-snc-card]').forEach(syncHeart);
  }
  document.addEventListener('sannico:wishlist:change', syncAllHearts);
  window.addEventListener('storage', function(e) { if (e.key === WISHLIST_KEY) syncAllHearts(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
